import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'

export interface UIButtonAccentProps extends
  Omit<UIButtonProps, 'variant'> {
}

/**
 * Accent Button Component
 * Uses Seahorse brand orange color for call-to-action buttons
 * Perfect for highlighting important actions, CTAs, and featured content
 */
export const UIButtonAccent = React.forwardRef<HTMLButtonElement, UIButtonAccentProps>(
  (props, ref) => {
    return (
      <UIButton
        variant="accent"
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonAccent.displayName = "UIButtonAccent"